import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

const GetQueryLogs: React.FC = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleSilentCall = async () => {
      const tenant = searchParams.get("tenant");
      const key = searchParams.get("key");

      const params = {
        key: key,
      };

      try {
        await axios.post("/snotes/api/querySwitch/clearLog", params, {
          headers: {
            "X-TENANT-ID": tenant,
          },
        });
      } catch (error) {
      } finally {
        setTimeout(() => {
          window.close();
        }, 500);
      }
    };

    handleSilentCall();
  }, [searchParams]);

  return null;
};

export default GetQueryLogs;
